window.formateBlogDate = function (dates, monthSeparator, dateSeparator, postfix) {
  let dateString = new Date(dates)
    .toISOString()
    .split('T')[0]
    .replace('-', monthSeparator)
    .replace('-', dateSeparator)

  return `${dateString}${postfix}`
}

window.getArticleImage = function (image, height, width) {
  if (!image) {
    return '<img src="" alt="" />'
  }

  return `<img 
    src="${image.src}" 
    class="lozad" 
    title="${image.alt}" 
    width="${width}" 
    height="${height}" 
    alt="" />`
}

window.formatTags = function (article) {
  const tag = article.article.tags.split(',')

  let tagHtml = ''

  tag.forEach((t) => {
    t = t.trim()
    const tLink = t.replace(/ /g, '-')

    tagHtml += `<li>
      <a href="/blogs/${article.Blog.details.handle}/tagged/${tLink}">${t}</a>
    </li>`
  })

  return tagHtml
}

window.formatRelatedArticleTags = function (article) {
  const tag = article.article.tags.split(',')

  let tagHtml = ''

  tag.forEach((t) => {
    t = t.trim()
    const tLink = t.replace(/ /g, '-')

    tagHtml += `<li>
      <a href="/blogs/${article.blog.details.handle}/tagged/${tLink}">${t}</a>
    </li>`
  })

  return tagHtml
}

window.stripHtml = function (unsafe, textLength) {
  if (!textLength) {
    textLength = 6
  }

  return $($.parseHTML(unsafe)).text().substring(0, textLength)
}

window.getBlogSidebar = async function () {
  const response = await fetch(window.getAppUrl('webhooks/get/blogs'))

  return await response.json()
}

window.processArchiveData = function (array) {
  const output = []

  array.forEach((item) => {
    const existing = output.filter((v, i) => {
      return v.year == item.year
    })

    if (existing.length) {
      const existingIndex = output.indexOf(existing[0])

      output[existingIndex].months = output[existingIndex].months.concat(
        item.months
      )
    } else {
      if (typeof item.months == 'object') {
        item.months = item.months
      }

      output.push(item)
    }
  })

  return output
}

window.createMonthArchive = function (archive) {
  let monthHtml = ''

  archive.months.forEach((month) => {
    monthHtml += `<li>
      <a href="/blogs/${month.handle}/tagged/${archive.year}-${month.tag.toLowerCase()}">
        ${month.tag}
      </a>
    </li>`
  })

  return monthHtml
}

window.getArticleMetaField = async function (blogHandle,articleHandle) {
  const requestUrl = `/blogs/${blogHandle}/${articleHandle}?view=json`

  const result = await Promise.resolve($.get(requestUrl))

  return JSON.parse(result)
}
